export default function ProfileIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0026 1.3335C11.6826 1.3335 14.6693 4.32016 14.6693 8.00016C14.6693 11.6802 11.6826 14.6668 8.0026 14.6668C4.3226 14.6668 1.33594 11.6802 1.33594 8.00016C1.33594 4.32016 4.3226 1.3335 8.0026 1.3335ZM4.01794 10.2775C4.9966 11.7375 6.46594 12.6668 8.10927 12.6668C9.75194 12.6668 11.2219 11.7382 12.1999 10.2775C11.0904 9.24056 9.6279 8.6647 8.10927 8.66683C6.59041 8.66453 5.12761 9.2404 4.01794 10.2775V10.2775ZM8.0026 7.3335C8.53304 7.3335 9.04175 7.12278 9.41682 6.74771C9.79189 6.37264 10.0026 5.86393 10.0026 5.3335C10.0026 4.80306 9.79189 4.29436 9.41682 3.91928C9.04175 3.54421 8.53304 3.3335 8.0026 3.3335C7.47217 3.3335 6.96346 3.54421 6.58839 3.91928C6.21332 4.29436 6.0026 4.80306 6.0026 5.3335C6.0026 5.86393 6.21332 6.37264 6.58839 6.74771C6.96346 7.12278 7.47217 7.3335 8.0026 7.3335V7.3335Z"
        fill={props.fill || "#0A0F29"}
        fillOpacity={props.fillOpacity || "0.25"}
      />
    </svg>
  );
}
